export default __webpack_public_path__ + "static/Genuine Parts – Primary – 800x400-a690eeed135ec230b91c6dd987d6db37.svg";